"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwilioRemoteAudioTrack = exports.TwilioLocalAudioTrack = void 0;
const twilio_video_1 = require("twilio-video");
const rxjs_1 = require("rxjs");
const toolbox_1 = require("@streem/toolbox");
const logger_1 = require("../../util/logger");
const contextValues_1 = require("@streem/logger/lib/contextValues");
class TwilioAudioTrack {
    constructor(track) {
        var _a;
        this.track = track;
        this.kind = 'audioTrack';
        this.audioLevelSubject = new rxjs_1.BehaviorSubject(0);
        this.boundHandleDocumentFocus = this.handleDocumentFocus.bind(this);
        this.enabled = new rxjs_1.Observable(subscriber => {
            const enabler = () => {
                logger_1.logger.info('audioTrackEvent=unmuted');
                subscriber.next(true);
            };
            const disabler = () => {
                logger_1.logger.info('audioTrackEvent=muted');
                subscriber.next(false);
            };
            track.on('enabled', enabler);
            track.on('disabled', disabler);
            subscriber.add(() => {
                track.off('enabled', enabler);
                track.off('disabled', disabler);
            });
            subscriber.next(track.isEnabled);
        });
        this.started = new rxjs_1.Observable(subscriber => {
            const starter = () => subscriber.next(true);
            track.on('started', starter);
            subscriber.add(() => {
                track.off('started', starter);
            });
            subscriber.next(track.isStarted);
        });
        // Some browsers will stop the audio track if the page is inactive
        // We will preemptively restart the audio track in the event that the application loses and regains focus
        document.addEventListener('visibilitychange', this.boundHandleDocumentFocus, true);
        track.on('started', () => {
            logger_1.logger.setContextValue(contextValues_1.contextValues.AUDIO_TRACK_SETTINGS, track.mediaStreamTrack.getSettings());
            logger_1.logger.info(`audioTrackEvent=started audioTrackSettings=${JSON.stringify(track.mediaStreamTrack.getSettings())}`);
            logger_1.logger.removeContextValue(contextValues_1.contextValues.AUDIO_TRACK_SETTINGS);
            (0, toolbox_1.pollAudioLevel)({
                track: track.mediaStreamTrack,
                onLevelChanged: (newLevel) => {
                    this.audioLevelSubject.next(newLevel);
                },
                onError: (message, err) => logger_1.logger.error(message, err),
            });
        });
        track.on('stopped', () => {
            document.removeEventListener('visibilitychange', this.boundHandleDocumentFocus, true);
            logger_1.logger.info('audioTrackEvent=stopped');
        });
        this.audioLevel = this.audioLevelSubject.asObservable();
        this.trackLabel = ((_a = track === null || track === void 0 ? void 0 : track.mediaStreamTrack) === null || _a === void 0 ? void 0 : _a.label) || '';
    }
    handleDocumentFocus() {
        return __awaiter(this, void 0, void 0, function* () {
            if (document.visibilityState === 'visible' && this.track instanceof twilio_video_1.LocalAudioTrack) {
                // The browser can decide which device to assign a track when it is restarted
                // We request the existing deviceId to maintain continuity with the currently assigned audio input device
                const deviceId = this.track.mediaStreamTrack.getSettings().deviceId;
                yield this.track.restart({ deviceId });
                logger_1.logger.info('Browser tab re-focused. Local audio track was restarted audioTrackEvent=restarted');
            }
        });
    }
}
class TwilioLocalAudioTrack extends TwilioAudioTrack {
    restart(constraints) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.track.restart(constraints);
                return true;
            }
            catch (error) {
                logger_1.logger.error(`audioTrackEvent=restartFailed`, error);
                return false;
            }
        });
    }
    setEnabled(enable) {
        if (enable === true) {
            this.track.enable();
        }
        else {
            this.track.disable();
        }
    }
}
exports.TwilioLocalAudioTrack = TwilioLocalAudioTrack;
class TwilioRemoteAudioTrack extends TwilioAudioTrack {
    constructor(track) {
        super(track);
        this.track = track;
        (0, toolbox_1.webkitAudioFix230902)(track.mediaStreamTrack);
        this.audioTrackSubject = new rxjs_1.BehaviorSubject(this.track.attach());
        this.audioTrack = this.audioTrackSubject.asObservable();
        this.logger = logger_1.logger.extend('twilio-remote-audio-track');
    }
    selectSpeaker(deviceId, userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            this.audioTrack
                .pipe((0, rxjs_1.filter)(audioElement => audioElement !== undefined))
                .pipe((0, rxjs_1.take)(1))
                .subscribe({
                next: (audioElement) => {
                    // @ts-ignore
                    audioElement.setSinkId(deviceId).then(() => {
                        document.body.appendChild(audioElement);
                    });
                    this.logger.info(`selected Speaker for tracksource is ${deviceId} of Participant: ${userSid}`);
                },
            });
        });
    }
}
exports.TwilioRemoteAudioTrack = TwilioRemoteAudioTrack;
//# sourceMappingURL=audio_tracks.js.map